import React from "react";

export const CallForPapersVersionBanner = () => {
    return <div className="version-banner">
        Es wird die Arbeitskopie des Call For Papers angezeigt.
        Änderungen werden erst nach Veröffentlichung wirksam.
        Dieser grüne Balken erscheint nicht in der veröffentlicheten Version.
        {/*<a href="#">Zur aktuell veröffentlichten Version wechseln</a>*/}
    </div>;
};
